import { TCategoryFilter, TdefaultSearchResultsPaging, TSearchResultsQueryParams } from './types';

export const defaultSearchFilter = '*';

export const searchResultsQueryParams: TSearchResultsQueryParams = {
  ps: 'ps',
  f: 'f',
  searchResults: 'searchResults',
};

export const categoryFilters: TCategoryFilter[] = [
  {
    label: 'All',
    filter: defaultSearchFilter,
  },
  {
    label: 'Help',
    filter: '1xhelp',
  },
];

export const defaultSearchResultsPaging: TdefaultSearchResultsPaging = {
  page: 1,
  pageSize: 10,
  sortBy: 'relevance',
  sortOrder: 'desc',
};

export const pageResultsLoadIncrease = 10;
